import { z } from "zod";

export const ReviewSchema = z.object({
  id: z.string(),
  author_name: z.string(),
  profile_photo_url: z.string(),
  rating: z.number(),
  text: z.string(),
  relative_time: z.string(),
  publish_time: z.string(),
});

export const ReviewsResponseSchema = z.object({
  rating: z.number().nullable(),
  user_rating_count: z.number(),
  reviews: ReviewSchema.array(),
});

export type Review = z.infer<typeof ReviewSchema>;
export type ReviewsResponse = z.infer<typeof ReviewsResponseSchema>;
